import { useEffect, useState } from "react";
import { authApi } from "api/auth/api";
import cn from "classnames";
import { AUTH_ROUTE, SIGN_IN_ROUTE } from "constants/routesValues";
import { SITE_NAME } from "constants/siteName";
import { useSiteName } from "context/SiteName.context";
import { CONFIG_ROUTES } from "router/Routes";
import "assets/styles/index.scss";
import style from "./App.module.scss";

const resolvePath = (path: string) => {
  if (path === AUTH_ROUTE || path === `${AUTH_ROUTE}/`) {
    return SIGN_IN_ROUTE;
  }
  return path;
};

export const App = () => {
  const { siteName } = useSiteName();
  const [isAuthChecked, setIsAuthChecked] = useState<boolean>(false);
  const [page, setPage] = useState(() => {
    const path = window.location.pathname;
    const resolved = resolvePath(path);
    if (resolved !== path) {
      window.history.replaceState(window.history.state, "", resolved);
    }
    return resolved;
  });

  useEffect(() => {
    const handlePopState = () => {
      const path = window.location.pathname;
      const resolved = resolvePath(path);
      if (resolved !== path) {
        window.history.replaceState(window.history.state, "", resolved);
      }
      setPage(resolved);
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      authApi
        .getUser()
        .then((response) => {
          localStorage.setItem("user", JSON.stringify(response.data));
          window.location.href = "/";
        })
        .catch(() => {
          localStorage.removeItem("user");
          setIsAuthChecked(true);
        });
    } else {
      window.location.href = "/";
    }
  }, []);

  return (
    <div
      className={cn(style.appShell, {
        [style.appShellChineseBrothers]: siteName === SITE_NAME.CHINESE_BROTHERS,
      })}
    >
      {isAuthChecked ? CONFIG_ROUTES[page] : null}
    </div>
  );
};
